import React from 'react';
import { Award } from 'lucide-react';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#1e3a8a] text-white py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8">
          <div>
            <h3 className="text-2xl font-bold mb-3">Brahmaputra Infotech</h3>
            <p className="text-blue-200 mb-4">Technology Procurement & Solutions</p>
            <div className="flex items-center space-x-2 text-blue-100">
              <Award size={20} />
              <span className="font-medium">Authorized Seller on GeM</span>
            </div>
          </div>

          <div className="md:text-right">
            <p className="text-blue-200 mb-2">Guwahati, Assam, India</p>
            <p className="text-blue-200">info@brahmaputrainfotech.com</p>
          </div>
        </div>

        <div className="border-t border-blue-800 pt-8 text-center">
          <p className="text-blue-200">
            © {currentYear} Brahmaputra Infotech. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};